angular.module("dettaglioCanone.components", [])
    .component("dettaglioCanone", {
        templateUrl: "ng/components/dettaglioContratto/dettaglioCanone/dettaglioCanone.view.html",
        bindings: {
            listCanone: "=",
            isLoad: "<"
        },
        controllerAs: "dettaglioCanoneCtrl",

        controller: function DettaglioCanone() {
            var self = this;

            self.$onInit = function () {

                self.listCanone = self.listCanone
                self.isLoad = self.isLoad;

            };

        }
    });
